import { apiClient, apiRequest, withToken } from './http-client';

export const createSupportTicket = async (token, {
    subject,
    description,
    category = 'INCIDENT',
    priority = 'MEDIUM',
    attachments = [],
} = {}) => {
    const formData = new FormData();

    formData.append('subject', String(subject || '').trim());
    formData.append('description', String(description || '').trim());
    formData.append('category', String(category || 'INCIDENT').trim().toUpperCase());
    formData.append('priority', String(priority || 'MEDIUM').trim().toUpperCase());

    if (Array.isArray(attachments)) {
        attachments.forEach((file) => {
            if (file) {
                formData.append('attachments', file);
            }
        });
    }

    return apiRequest({
        method: 'post',
        url: '/support',
        headers: withToken(token),
        data: formData,
    }, 'No se pudo crear el reporte de soporte');
};

export const getSupportTickets = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/support',
        headers: withToken(token),
        params,
    }, 'No se pudieron obtener los reportes de soporte');
};

export const downloadSupportAttachment = async (token, ticketId, attachmentId) => {
    try {
        const response = await apiClient({
            method: 'get',
            url: `/support/${ticketId}/attachments/${attachmentId}/content`,
            headers: withToken(token),
            responseType: 'blob',
        });

        return {
            success: true,
            data: response?.data,
            contentType: response?.headers?.['content-type'] || 'application/octet-stream',
        };
    } catch (error) {
        return {
            success: false,
            message: error?.message || 'No se pudo descargar el adjunto',
        };
    }
};
